import { CART_MAX_ITEMS } from "./constants.js";
function getCartAriaLabel(count, title, descriptionSingle, descriptionMultiple) {
  if (count === 0) {
    return title;
  }
  if (count === 1) {
    return `${title}, 1 ${descriptionSingle}`;
  }
  if (count > 1 && count <= CART_MAX_ITEMS) {
    return `${title}, ${count} ${descriptionMultiple}`;
  }
  if (count > CART_MAX_ITEMS) {
    return `${title}, ${CART_MAX_ITEMS}+ ${descriptionMultiple}`;
  }
  return "";
}
export {
  getCartAriaLabel
};
